import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "px-5" }

import { ref, reactive } from "vue";
import SimpleForm from "@/components/SimpleForm.vue";
import type { FormInstance } from "element-plus";
import MsgPrompt from "@/core/plugins/MsgPrompt";


export default /*#__PURE__*/_defineComponent({
  __name: 'CancelOrder',
  emits: ["submit"],
  setup(__props, { expose: __expose, emit: emits }) {


const isSubmitting = ref(false);
const modalRef = ref<InstanceType<typeof SimpleForm>>();

const hide = () => {
  modalRef.value?.hide();
};

const ruleFormRef = ref<FormInstance>();
const rules = reactive<any>({
  comment: [
    {
      required: true,
      message: "Please input tracking number",
      trigger: "blur",
    },
  ],
});
const formData = ref<any>({});

const show = async (_item: any) => {
  if (_item != null) {
    formData.value = _item;
  }
  modalRef.value?.show();
};

const submit = async () => {
  if (!ruleFormRef.value) return;

  let isValid = false;
  await ruleFormRef.value.validate(async (valid, fields) => {
    isValid = valid;
  });
  if (!isValid) return;
  try {
    // const res = await ShopService.updateItem(formData.value);
    // MsgPrompt.success("Item updated successfully");
  } catch (error) {
    console.log(error);
  }
  emits("submit");
};
__expose({
  show,
  hide,
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(SimpleForm, {
    ref_key: "modalRef",
    ref: modalRef,
    title: "Are you confirm to cancel this order?",
    "is-loading": isSubmitting.value,
    submit: submit,
    "before-close": hide
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createVNode(_component_el_form, {
            ref_key: "ruleFormRef",
            ref: ruleFormRef,
            model: formData.value,
            rules: rules,
            "label-position": "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "Reason for Cancel",
                prop: "comment"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: formData.value.customer.comment,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.customer.comment) = $event)),
                    autosize: { minRows: 6, maxRows: 10 },
                    type: "textarea"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["is-loading"]))
}
}

})